import React, {Component} from "react";
import {connect} from "react-redux";
// import ewalleticon from "../../../assets/img/payment/ewallet.png";
import accntHeadIcon from "../../../assets/img/payment/account.png";
import cardicon from "../../../assets/img/payment/card.png";

import cashicon from "../../../assets/img/payment/cash.png";
import fonepayLogo from "../../../assets/img/payment/Fonepay.png";
import nepalPayLogo from "../../../assets/img/payment/NepalPay.png";
import {OtherPayment, RefreshTable} from "../../../redux/actions/Cart.Action";
import ApiConnect from "../../../Utils/ApiConnect";
import AccountHead from "./Payment/AccountHead";
import Card from "./Payment/Card";

import Cash from "./Payment/Cash";
import Fonepay from "./Payment/Fonepay";
import NepalPay from "./Payment/NepalPay";

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartTotal: this.props.CurrentCart ? this.props.CurrentCart.total : 0,
      cashOption: true,
      cardOption: false,
      EwalletOption: false,
      customerEmail: "",
      customerContact: "",
      smsModal: false,
      emailModal: false,
      membership: this.props.CurrentCart
        ? this.props.CurrentCart.membership
        : false,
      contact: 0,
      PaymentView: <Cash />,
    };
    // this.GetPrintSettings();
  }
  GetPrintSettings() {
    ApiConnect.get("/Module/Settings/PrintSettings/Details?name=pos_invoice")
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => console.log(error));
  }
  GetPaymentOptions(opt) {
    switch (opt) {
      case "CASHOPTION":
        this.props.OtherPayment("Cash", this.state.cartTotal, "");
        this.setState({ PaymentView: <Cash /> });
        break;
      case "CARDOPTION":
        this.props.OtherPayment("Card", this.state.cartTotal, "");
        this.setState({ PaymentView: <Card /> });
        break;
      case "FONEPAY":
        this.props.OtherPayment("Fonepay", this.state.cartTotal, "");
        this.setState({
          PaymentView: (
            <Fonepay
              autoCheckout={false}
              total={this.state.cartTotal}
              order_id={
                this.props.CurrentCart ? this.props.CurrentCart.order_id : ""
              }
            />
          ),
        });
        break;
      case "NEPALPAY":
        this.props.OtherPayment("NepalPay", this.state.cartTotal, "");
        this.setState({
          PaymentView: (
            <NepalPay
              total={this.state.cartTotal}
              order_id={
                this.props.CurrentCart ? this.props.CurrentCart.order_id : ""
              }
            />
          ),
        });
        break;
      case "ACCOUNTHEAD":
        this.setState({
          PaymentView: (
            <AccountHead
              total={this.state.cartTotal}
              order_id={
                this.props.CurrentCart ? this.props.CurrentCart.order_id : ""
              }
            />
          ),
        });
        break;
      default:
        break;
    }
  }
  GetMembersDetails(number) {
    ApiConnect.get("POS/Inventory/MemberDetails?member=" + number)
      .then((response) => {
        this.setState({ membership: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleModalClose = () => {
    this.setState({ smsModal: false, emailModal: false });
  };
  render() {
    return (
      <div className="container">
        {/* <div className="col-md-3 br-1 h-100 ">
            <Scrollbars
              className="p-1"
              style={{ height: "calc(100vh - 25ex)", overflowX: "hidden" }}
            >
              <ReceiptPrint
                ref={(el) => (this.componentRef = el)}
                Userchange={this.state.change}
                UsercashIn={this.state.cashin}
                CurrentCartOrder={this.props.CurrentCartOrder}
                CurrentCart={this.props.CurrentCart || []}
                CompanyInfo={this.props.CompanyInfo}
              />
            </Scrollbars>
            <div className="row d-flex h-80px col-4 w-100 bottom-0">
              <ReactToPrint
                documentTitle={
                  this.props.CurrentCart.order_id + this.props.CurrentCart.table
                }
                pageStyle={InvoiceCss}
                copyStyles={false}
                trigger={() => {
                  return (
                    <button className="col w-100 btn btn-warning btn-multiline btn btn-w-lg align-self-center p-20">
                      <span className="material-icons-outlined fs-35">
                        print
                      </span>
                    </button>
                  );
                }}
                content={() => this.componentRef}
              />
              <button
                className="col w-100 btn btn-primary btn-multiline btn btn-w-lg align-self-center p-20"
                onClick={(e) => {
                  this.setState({ emailModal: true });
                }}
              >
                <span className="material-icons-outlined fs-35">
                  forward_to_inbox
                </span>
              </button>
              <button
                className="col w-100 btn btn-info btn-multiline btn btn-w-lg align-self-center p-20"
                onClick={(e) => {
                  this.setState({ smsModal: true });
                }}
              >
                <span className="material-icons-outlined fs-35">textsms</span>
              </button>
             
            </div>
          </div> */}
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <span className="fs-2 text-success d-flex justify-content-center p-3">
                  Total Amount : रु {this.props.CurrentCart.total}
                </span>
                <div className="d-flex justify-content-center">
                  <ul className="list-unstyled list-inline">
                    <li className="list-inline-item">
                      <button
                        className="m-1 btn btn-w-lg btn-outline btn-multiline btn-success w-100 active-success"
                        onClick={() => this.GetPaymentOptions("CASHOPTION")}
                      >
                        <img src={cashicon} alt="cashpayment" height="30" />
                        <br />
                        Cash
                      </button>
                    </li>
                    <li className="list-inline-item">
                      <button
                        className="m-1 btn btn-outline btn-w-lg btn-multiline btn-info w-100 active-info"
                        onClick={() => this.GetPaymentOptions("CARDOPTION")}
                      >
                        <img src={cardicon} alt="cardpayment" height="30" />
                        <br />
                        Card
                      </button>
                    </li>
                    <li className="list-inline-item">
                      <button
                        className="m-1 btn btn-outline btn-w-lg btn-multiline btn-warning w-100 active-warning"
                        onClick={(e) =>
                          this.GetPaymentOptions("NEPALPAY")
                        }
                      >
                        <img
                          src={nepalPayLogo}
                          alt="NEPALPAY"
                          width="60"
                          className="py-2"
                        />
                        <br /> NepalPay
                      </button>
                    </li>
                    <li className="list-inline-item">
                      <button
                        className="m-1 btn btn-outline btn-w-lg btn-multiline btn-danger w-100 active-"
                        onClick={() => this.GetPaymentOptions("FONEPAY")}
                      >
                        <img
                          src={fonepayLogo}
                          alt="Fonepay"
                          width="60"
                          className="py-2"
                        />
                        <br /> Fonepay
                      </button>
                    </li>
                    <li className="list-inline-item">
                      <button
                        className="m-1 btn btn-outline btn-w-lg btn-multiline btn-warning w-100 active-warning"
                        onClick={() => this.GetPaymentOptions("ACCOUNTHEAD")}
                      >
                        <img
                          src={accntHeadIcon}
                          alt="Account Head"
                          width="30"
                        />
                        <br /> Account Heads
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.PaymentView}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    CurrentCartOrder: state.Cart.CurrentCart.order,
    CurrentCart: state.Cart.CurrentCart,
  }),
  { OtherPayment, RefreshTable }
)(Checkout);
